import { render } from "./KoruWarehouseLocation.vue?vue&type=template&id=3e763fcc&ts=true"
import script from "./KoruWarehouseLocation.vue?vue&type=script&lang=ts"
export * from "./KoruWarehouseLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__